// El orden del equipo que se VE en la lista (grupos por situación, con «Con Santi»), para quien recorre el equipo sin la
// lista delante: el riel plegado y Alt+↑/↓ en el chat. Una sola pieza para que nadie se deje fuera los contratos con
// Santi (03-11: el teclado saltaba en otro orden del que se veía).
import { useMemo } from 'react';
import type { ContratadoDTO } from '../compartido/vocabulario';
import { useSantiPorAgente } from '../pelotas/porAgente';
import { ordenarPorSituacion } from './situacion';

const NO_LEIDO = (c: ContratadoDTO) => c.noLeido;

export function useOrdenEquipo<C extends ContratadoDTO>(visibles: readonly C[], noLeido: (c: C) => boolean = NO_LEIDO): C[] {
  const santi = useSantiPorAgente();
  return useMemo(() => ordenarPorSituacion(visibles, noLeido, santi), [visibles, noLeido, santi]);
}
